/* globals navigator */

import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
// import { add as addCustomer } from 'redux/customer/sagas';
// import { get as getClub } from 'redux/clubs/sagas';
import {
  getReservation,
  getReservationByEmailReservationNumber
} from 'redux/reservations/api';
import { GET_RESERVATION_SUCCESS } from 'redux/reservations/constants';

import {
  getReservationCart,
  updateReservationCart,
  createReservationCart,
  processReservationCart
} from './api';
import {
  UPDATE_RESERVATION_CART_REQUEST,
  GET_RESERVATION_CART_REQUEST,
  GET_RESERVATION_CART_REQUESTING,
  GET_RESERVATION_CART_SUCCESS,
  RESET_RESERVATION_CART_ISFETCHING,
  PROCESS_RESERVATION_CART_REQUEST,
  CREATE_RESERVATION_CART_REQUEST,
  UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST,
  RESERVATION_CHECKOUT_STEP_REQUEST,
  RESERVATION_CHECKOUT_STEP_REQUEST_GTM,
  CHARGE_RESERVATION_CART_SUCCESS_GTM
} from './constants';

export function* get() {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_RESERVATION_CART_REQUESTING });
    if (!reservationCartId()) {
      yield put({ type: GET_RESERVATION_CART_SUCCESS, payload: {} });
    } else {
      const response = yield call(getReservationCart, reservationCartId());
      yield put({ type: GET_RESERVATION_CART_SUCCESS, payload: response.data });
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      Cookies.remove('reservationCartId');
      yield put({ type: GET_RESERVATION_CART_SUCCESS, payload: {} });
    } else {
      yield put({ type: RESET_RESERVATION_CART_ISFETCHING });
      yield call(addAPIError, error);
    }
  }
}

export function* create(action) {
  try {
    const newReservationCart = action.reservationCart;
    newReservationCart.channel = 'Web';
    if (!reservationCartId()) {
      if (Cookies.get('customerToken')) {
        newReservationCart.customerId = jwtDecode(
          Cookies.get('customerToken')
        ).sub;
      }
      newReservationCart.connectionInformation = {
        userAgent: navigator.userAgent
      };
      yield put({ type: GET_RESERVATION_CART_REQUESTING });
      const response = yield call(createReservationCart, newReservationCart);
      Cookies.set('reservationCartId', response.data.id, {
        expires: 365,
        secure: process.env.NODE_ENV === 'production'
      });
      yield put({ type: GET_RESERVATION_CART_SUCCESS, payload: response.data });
      if (action.successFunction) {
        action.successFunction(response.data);
      }
    } else {
      yield call(update, {
        reservationCart: newReservationCart,
        successFunction: action.successFunction
      });
    }
  } catch (error) {
    yield put({ type: RESET_RESERVATION_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* update(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_RESERVATION_CART_REQUESTING });
    const response = yield call(
      updateReservationCart,
      reservationCartId(),
      action.reservationCart
    );
    yield put({ type: GET_RESERVATION_CART_SUCCESS, payload: response.data });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_RESERVATION_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* updateAndProcess(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_RESERVATION_CART_REQUESTING });
    const reservationCart = yield call(
      updateReservationCart,
      reservationCartId(),
      action.reservationCart
    );
    yield put({
      type: GET_RESERVATION_CART_SUCCESS,
      payload: reservationCart.data
    });
    const finalReservationCart = yield call(
      processReservationCart,
      reservationCartId()
    );
    yield put({
      type: GET_RESERVATION_CART_SUCCESS,
      payload: finalReservationCart.data
    });
    Cookies.remove('reservationCartId');
    let response;
    if (Cookies.get('customerToken')) {
      response = yield call(
        getReservation,
        finalReservationCart.data.customerId,
        finalReservationCart.data.reservationId
      );
    } else {
      response = yield call(
        getReservationByEmailReservationNumber,
        finalReservationCart.data.email,
        finalReservationCart.data.reservationNumber
      );
    }
    yield put({ type: GET_RESERVATION_SUCCESS, payload: response.data });
    yield put({
      type: CHARGE_RESERVATION_CART_SUCCESS_GTM,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_RESERVATION_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* processForReservation(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_RESERVATION_CART_REQUESTING });
    const finalReservationCart = yield call(
      processReservationCart,
      reservationCartId()
    );
    yield put({
      type: GET_RESERVATION_CART_SUCCESS,
      payload: finalReservationCart.data
    });
    Cookies.remove('reservationCartId');
    const response = yield call(
      getReservation,
      finalReservationCart.data.customerId,
      finalReservationCart.data.reservationId
    );
    yield put({ type: GET_RESERVATION_SUCCESS, payload: response.data });
    yield put({
      type: CHARGE_RESERVATION_CART_SUCCESS_GTM,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_RESERVATION_CART_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* checkoutStep(action) {
  const { step } = action.payload;
  yield put({
    type: RESERVATION_CHECKOUT_STEP_REQUEST_GTM,
    payload: {
      step
    }
  });
}

export function* watchList() {
  yield takeLatest(GET_RESERVATION_CART_REQUEST, get);
  yield takeLatest(UPDATE_RESERVATION_CART_REQUEST, update);
  yield takeLatest(PROCESS_RESERVATION_CART_REQUEST, processForReservation);
  yield takeLatest(
    UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST,
    updateAndProcess
  );
  yield takeLatest(CREATE_RESERVATION_CART_REQUEST, create);
  yield takeLatest(RESERVATION_CHECKOUT_STEP_REQUEST, checkoutStep);
}

export default function* reservationCartSagas() {
  yield all([watchList()]);
}

const reservationCartId = () => Cookies.get('reservationCartId');
